// extracted by mini-css-extract-plugin
module.exports = {"bill-block":"common_bill-block__F-ezV","bill-block-title":"common_bill-block-title__2qW3J"};